import {useEffect} from 'react'
import {useObvioAuth} from 'obvio/auth'
import {useQueryParams} from 'lib/url'

/**
 * Redirect URLs must be from one of these domains. Redirect URLs are meant
 * for internal services to authenticate as an existing obvio user.
 * Similar to how OAuth works.
 */
const ALLOWED_REDIRECT_DOMAINS = [
  'chat.obv.io',
  'eventgfx.com',
  'localhost:3000',
  'localhost',
]

function getValidatedRedirectUrl(
  redirectUrl: string | undefined,
): string | null {
  if (!redirectUrl) {
    return null
  }

  try {
    const url = new URL(redirectUrl)
    if (ALLOWED_REDIRECT_DOMAINS.includes(url.hostname)) {
      return redirectUrl
    }
  } catch {
    // Invalid URL
  }

  return null
}

export function useLoginRedirect() {
  const {user, token} = useObvioAuth()
  const {redirect_url} = useQueryParams()
  const redirectUrl = getValidatedRedirectUrl(redirect_url)

  const isRedirecting = Boolean(user && token && redirectUrl)

  useEffect(() => {
    if (!user || !token || !redirectUrl) {
      return
    }

    const url = new URL(redirectUrl)
    url.searchParams.set('obvio_access_token', token)
    window.location.href = url.toString()
  }, [user, token, redirectUrl])

  return {isRedirecting}
}
